import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const CrystalClearImagingContent = () => {
  return (
    <DoctorDetailPage
      name="Crystal Clear Imaging (IIMS Hospital)"
      specialization="Radiologist & Your Window to the Womb"
      experience="18 Years, specializing in obstetric ultrasonography"
      degrees="MBBS, MD (Radiodiagnosis), Fellowship in Foetal Medicine from Premier Medical Institute"
      quote="I believe I am becoming a pregnancy crafter who turns scans into clarity and reassurance."
      sections={[
        {
          title: "My Philosophy on Sonography",
          body: "We see ourself as a medical storyteller. Every scan is a crucial chapter in your pregnancy story, and we have the privilege of interpreting it for you. Our focus is on precision, detail, and, most importantly, communication. We take the time to explain what we are seeing, transforming a technical procedure into a moment of connection and reassurance. Our commitment is to ensure that you leave not just with a report, but with a clear understanding and a happy heart.",
        },
        {
          title: "Why I Chose Myprega",
          body: "Myprega's integrated system allows us to be a true partner in the care team. Our findings are instantly shared and discussed with your gynaecologist and other experts, creating a seamless flow of information. This collaborative approach ensures that every detail is considered, providing a level of safety and thoroughness that is simply not possible in a fragmented system.",
        },
        {
          title: "Beyond the Clinic",
          body: "I am a classical music enthusiast and a trained violinist. The discipline and focus required for music are the same skills I bring to my medical practice. I also have a passion for astrophotography, finding beauty and order in the patterns of the universe, much like I do in my daily work.",
        },
      ]}
      favorites={[
        { icon: "🎼", label: "Favourite Instrument", value: "Violin - both my hobby and my teacher" },
        { icon: "🌌", label: "Favourite Hobby", value: "Astrophotography - capturing the universe one frame at a time" },
        { icon: "💬", label: "Imaging Philosophy", value: "Every scan is a story - we help you read it with clarity and compassion." },
      ]}
    />
  );
};

export default CrystalClearImagingContent;
